import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {
  Exemption_5_2
} from '@portbase/bezoekschip-service-typescriptmodels';
import {ExemptionBaseComponent} from "../../common/exemption_base/exemption_base.component";

@Component({
    selector: 'app-visit-exemptions-exemption-5-2',
    templateUrl: './exemption_5_2.component.html',
    styleUrls: ['./exemption_5_2.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class Exemption_5_2Component extends ExemptionBaseComponent {

  @Input() exemption: Exemption_5_2;

  requestTypes: string[] = ['',
    'Vessel in petroleum port'
  ];
}

